import type { Random as IRandom } from '@jet/environment';
import type { LoggerFactory as ILoggerFactory } from '@jet-app/music-classical/dependencies/logger';
import { Bag } from '~/jet/dependencies/bag';
import { Bundle } from '@amp/web-apps-common/src/jet/dependencies/bundle';
import type { Prebootstrap } from '@jet-app/music-classical/bootstrap';
import { getFeatures, type Features } from '~/jet/dependencies/features';
import { Locale } from '~/jet/dependencies/locale';
import { LoggerFactory } from '@amp/web-apps-common/src/jet/dependencies/logger';
import { Host } from '@amp/web-apps-common/src/jet/dependencies/host';
import { Net, type UserCallbacks } from '~/jet/dependencies/net';
import { Random } from '@amp/web-apps-common/src/jet/dependencies/random';
import { createPreBootstrap } from '~/jet/intents';
import type { LoggerFactory as AppLoggerFactory } from '@amp/web-apps-logger';
import { Persistence } from '~/jet/dependencies/persistence';
import { SubscriptionStatusCoordinator } from '~/jet/dependencies/subscription-status-coordinator';
import { BUILD } from '~/config/build';
import { regions } from '~/utils/storefront-data';

export type { Bag } from './bag';
export type { Bundle } from '@amp/web-apps-common/src/jet/dependencies/bundle';
export type { Features } from '~/jet/dependencies/features';
export type { Host } from '@amp/web-apps-common/src/jet/dependencies/host';
export type { Locale } from '~/jet/dependencies/locale';
export type { LoggerFactory } from '@jet-app/music-classical/dependencies/logger';
export type { Net } from '~/jet/dependencies/net';
export type { Random } from '@jet/environment';
export type { SubscriptionStatusCoordinator } from '~/jet/dependencies/subscription-status-coordinator';

const buildBundle = Bundle.makeBuilder(BUILD, regions);

export function makeDependencies(
    loggerFactory: AppLoggerFactory,
    fetch: typeof window.fetch,
    origin: string,
    userCallbacks: UserCallbacks,
    defaultStorefront?: string,
): {
    bag: Bag;
    bundle: Bundle;
    features: Features;
    locale: Locale;
    loggerFactory: ILoggerFactory;
    host: Host;
    net: Net;
    persistence: Persistence;
    prebootstrap: Prebootstrap;
    random: IRandom;
    subscriptionStatusCoordinator: SubscriptionStatusCoordinator;
} {
    const bag = Bag.build(loggerFactory);

    return {
        bag,
        bundle: buildBundle(),
        features: getFeatures(),
        host: new Host(),
        locale: new Locale(defaultStorefront),
        loggerFactory: LoggerFactory.create(
            loggerFactory,
            'music-classical-client-js',
        ),
        net: new Net(fetch, userCallbacks),
        prebootstrap: createPreBootstrap(loggerFactory),
        random: new Random(),
        persistence: new Persistence(loggerFactory),
        subscriptionStatusCoordinator: new SubscriptionStatusCoordinator(
            bag,
            userCallbacks,
        ),
    };
}
